import { render } from "./enrolmentStep1.vue?vue&type=template&id=1da783fd"
import script from "./enrolmentStep1.vue?vue&type=script&lang=js"
export * from "./enrolmentStep1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__